import { useState, useEffect } from 'react';

/**
 * Hook personalizado para manejar el sistema de auditoría y métricas
 * (Vesion Local: Cloud Functions desactivadas)
 * @returns {Object} - Estado y funciones del sistema de auditoría
 */
export const useSistemaAudit = () => {
  const [showSistemaAudit, setShowSistemaAudit] = useState(false);
  const [sistemaAuditTab, setSistemaAuditTab] = useState("metricas");
  const [metricasSistema, setMetricasSistema] = useState(null);
  const [loadingMetricas, setLoadingMetricas] = useState(false);

  // Cargar métricas del sistema desde Firestore
  const cargarMetricasSistema = async (usuario) => {
    if (!usuario?.ruc) return;

    try {
      setLoadingMetricas(true);

      const { getFirestore, collection, query, where, getDocs } = await import('firebase/firestore');
      const firebaseApp = (await import('../../../firebase/credenciales')).default;
      const db = getFirestore(firebaseApp);

      // Obtener todas las planillas
      const planillasRef = collection(db, 'pl_planillas');
      const q = query(planillasRef, where('ruc_empresa', '==', usuario.ruc));
      const snapshot = await getDocs(q);

      let totalPlanillas = 0;
      let totalEmpleados = 0;
      let totalNeto = 0;

      snapshot.forEach(doc => {
        const planilla = doc.data();
        totalPlanillas++;
        totalEmpleados += planilla.total_empleados || 0;
        totalNeto += planilla.total_neto || 0;
      });

      setMetricasSistema({
        total_planillas: totalPlanillas,
        total_empleados: totalEmpleados,
        total_neto: totalNeto,
        tiempo_promedio_procesamiento: 150, // ms estimado
        operaciones_por_hora: Math.round((totalPlanillas * 60) / 24), // estimado
        tasa_error: 2.5 // % estimado
      });
    } catch (error) {
      console.error("Error al cargar métricas del sistema:", error);
      setMetricasSistema(null);
    } finally {
      setLoadingMetricas(false);
    }
  };

  return {
    showSistemaAudit,
    setShowSistemaAudit,
    sistemaAuditTab,
    setSistemaAuditTab,
    metricasSistema,
    loadingMetricas,
    recargarMetricas: cargarMetricasSistema
  };
};